// package imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// project imports
import routeName from 'core/common/routeName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';
import ContestHistoryDetails from 'pages/contest/contestHistory/contestHistoryDetails';

const ContestHistoryView = lazy(
  () => import('pages/contest/contestHistory/contestHistory')
);
const ContestHistoryRoute = (
  <Route path={routeName.contestHistory}>
    <Route
      index
      element={
        <PrivateRoute name={PrivateRouteConst.CONTEST_HISTORY}>
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <ContestHistoryView />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="show/:id/:calId"
      element={
        // <PrivateRoute
        //   name={[
        //     PrivateRouteConst.FREQUENCY_VIEW,
        //     PrivateRouteConst.SELF_FREQUENCY_DELETE,
        //   ]}
        // >
        <Suspense fallback={<Loading />}>
          <ContestHistoryDetails />
        </Suspense>
        // </PrivateRoute>
      }
    />
  </Route>
);

export default ContestHistoryRoute;
